<template>
  <div class="footer" id="web-footer">
    <div class="footer-content">
      <ul class="content-nav">
        <li>
          <a class="footer-title" @click="toGoin">关于我们</a>
          <a class="footer-span" @click="toGoin">公司简介</a>
          <a class="footer-span" @click="toGoin">发展历程</a>
          <a class="footer-span" @click="toGoin">资质荣誉</a>
          <a class="footer-span" @click="toGoin">合作伙伴</a>
        </li>
        <li>
          <a class="footer-title" @click="toNews">新闻资讯</a>
          <a class="footer-span" @click="toNews">公司新闻</a>
          <a class="footer-span" @click="toNews">行业动态</a>
        </li>
        <li>
          <a class="footer-title" @click="toProduct">产品中心</a>
          <a class="footer-span" @click="toProduct6">农网末端低电压治理装置</a>
          <a class="footer-span" @click="toProduct1">新能源光储充集成系统</a>
          <a class="footer-span" @click="toProduct2">综合能源服务平台</a>
          <!-- <a class="footer-span" @click="toProduct3">快速频率响应控制装置</a> -->
          <a class="footer-span" @click="toProduct5">无源传感器监测诊断系统</a>
          <a class="footer-span" @click="toProduct4">发电厂辅机控制系统</a>
        </li>
        <li>
          <a class="footer-title">联系我们</a>
          <span>邮箱：zhsn2014@163.com</span>
          <span>电话：18040558861</span>
          <span>地址：武汉东湖新技术开发区神墩五路76号多肽工业园26562</span>
        </li>
      </ul>
      <!-- <img src="../assets/img/ercode.png" alt /> -->
    </div>
    <div class="copyright">
      <span>版权所有：湖北中恒善能电力技术有限公司</span>
      <div style="width:300px;margin:0 auto; padding:3px 0;">
        <a target="_blank" href="https://beian.miit.gov.cn">
          <img src="../assets/img/ghs.png" style="float:left; margin-left:30px;">
          <p>鄂ICP备2021001691号</p>
        </a>

      </div>
     
    </div>
  </div>
</template>

<script>
export default {
  name: 'v-footer',
  data() {
    return{}
  },
  methods: {
    toGoin() {
      this.$router.push('/goin');
    },
    toNews() {
      this.$router.push('/news');
    },
    toProduct() {
      this.$router.push('/product');
    },
    toProduct1() {
      this.$router.push('/product1');
    },
    toProduct2() {
      this.$router.push('/product2');
    },
    toProduct3() {
      this.$router.push('/product3');
    },
    toProduct4() {
      this.$router.push('/product4');
    },
    toProduct5() {
      this.$router.push('/product5');
    },
    toProduct6() {
      this.$router.push('/product6');
    }
  }
};
</script>

<style lang="scss">
.footer {
  width: 100%;
  height: auto;
  // position: fixed;
  bottom: 0px;
  overflow: hidden;
  background-color: #14679f;
  &-content {
    width: 1240px;
    margin: 0 auto;
    padding-top: 20px;
    display: flex;
    justify-content: space-between;
    .content-nav {
      display: flex;
      justify-content: space-around;
  
      li {
        display: flex;
        flex-direction: column;
        padding: 0 20px;
        //justify-content: center;
        align-items: flex-start;
        a {
          font-size: 20px;
          color: #d4edff;
          display: block;
          padding: 10px 0;
        }
        .footer-span {
          color: #f7f7f7;
          font-size: 15px;
          font-weight: 300;
          padding: 5px 0;
        }
      }
    }
    img {
      width: 170px;
      height: 170px;
      padding: 10px;
    }
  }
  .copyright {
    margin-top: 10px;
    height: 40px;
    background: #125688;
    // background-image: url("./assets/img/new/foot.jpg");
    background-color: #14679f;
    align-content: center;
    span {
      // color: #fff;
      padding-top: 10px;
      line-height: 30px;
      text-align: center;
      display: block;
      position: relative;
    }
    a {
      color: #fff;
      //padding-top: 10px;
      line-height: 30px;
      text-align: center;
      display: block;
      position: relative;
    }
    img{
      display: inline-block;
      text-align: center;
    }
  }
}

.footer-title {
  cursor: pointer;
}

.footer-span {
  cursor: pointer;
}

.footer ul li:first-child a {
  font-size: 20px;
  color: #d4edff;
}

.footer ul li a {
  text-decoration: none;
  color: #f7f7f7;
}

.footer ul li a:hover {
  color: #89d0f9;
}

.footer-content ul li a:hover {
  color: #89d0f9;
}
  
</style>